'use client';

import { forwardRef, useMemo } from 'react';

import { css, cx } from '@/styled-system/css';

import { AvatarRootContext } from './context/avatar-root.context';
import { avatarRecipe } from './styles/avatar-root.styles';
import type { AvatarRootPropsInterface } from './types/avatar-root.types';

/**
 * @since 10.0.0
 */
export const AvatarRoot = forwardRef<HTMLDivElement, AvatarRootPropsInterface>(
  (props: AvatarRootPropsInterface, forwardedRef) => {
    const { tone = 'default', children, className, css: cssProp, size = 'lg', ...rest } = props;

    const styles = css(avatarRecipe.raw({ tone, size }), cssProp);

    const contextValue = useMemo(
      () => ({
        tone: tone,
        size: size,
      }),
      [tone, size],
    );

    return (
      <AvatarRootContext.Provider value={contextValue}>
        <div
          ref={forwardedRef}
          data-c11n-component="Avatar.Root"
          data-c11n-version={__C11N_VERSION__}
          className={cx('c11n', 'c11n_avatar__root', styles, className)}
          {...rest}
        >
          {children}
        </div>
      </AvatarRootContext.Provider>
    );
  },
);

AvatarRoot.displayName = 'Avatar.Root';
